import React from "react";
import "../styles/About.css";
import invoice from "../assets/invoice.png";

function About() {
  return (
    <div className="background">
      <div className="container">
        <div className="about-intro">
          <h1>Invoice Factoring That Works</h1>
          <p className="basic-text">
            Break cash flow barriers
            <br />
            Power your growth
          </p>
        </div>

        <div className="midtext">
          <p className="basic-text">
            Get the flexible funding your business needs—whether you’re bridging a gap or building a stronger financial foundation.
          </p>
        </div>
        <div className="h2-styling">
          <h2>Understanding Invoice Factoring and Funding</h2>
        </div>

        <p className="basic-text">
          What is invoice factoring? It’s a way for businesses to access funds immediately to support daily operations. Instead of waiting for customers to pay, you can sell your invoices and receive the funds right when you need them.
        </p>

        <div className="h2-styling">
          < h2 > The Benefits of Invoice Factoring</h2 >
        </div>
        <div className="cards">
          <div className="cardStyle"><div className="cardText"><h3>Improved Cash Flow</h3><p>Don’t wait weeks & months to get paid—turn invoices into cash almost instantly
          </p></div></div>
          <div className="cardStyle"><div className="cardText"><h3>Enhanced Working Capital</h3><p> Unlock instant cash and put it to work right away</p></div></div>
          <div className="cardStyle"><div className="cardText"><h3>Risk Mitigation</h3><p>Stay prepared and in control with steady cash flow </p></div></div>
          <div className="cardStyle"><div className="cardText"><h3>Reduced Financial Stress</h3><p> Breathe easier knowing your bills are handled</p></div></div>
          <div className="cardStyle"><div className="cardText"><h3>Focus on Core Operations</h3><p> Run your business—we’ll take care of collections</p></div></div>
          <div className="cardStyle"><div className="cardText"><h3>Quick & Simple Process</h3><p> Fast, easy, and hassle-free from start to finish</p></div></div>
        </div>

        <div className="h2-styling">
          <h2>Is Invoice Factoring Right for You?</h2>
        </div>
        <p className="basic-text">
          Businesses experiencing cash flow constraints related to expenses, payroll, or growth initiatives may benefit from invoice factoring solutions.
        </p>

        <div className="cards">
          <div className="cardStyle"><div className="cardText"><h3>Inconsistent Cash Flow</h3><p> Variability in cash flow can hinder a company’s ability to meet ongoing financial obligations. Invoice factoring provides stability and supports uninterrupted operations.</p></div></div>
          <div className="cardStyle"><div className="cardText"><h3>Rapid Growth</h3><p> Expansion opportunities often require immediate access to capital. Factoring enables businesses to respond quickly and effectively.</p></div></div>
          <div className="cardStyle"><div className="cardText"><h3>Seasonal Fluctuations</h3><p> Seasonal demand cycles can create financial pressure. Invoice factoring helps maintain liquidity throughout the year.</p></div></div>
          <div className="cardStyle"><div className="cardText"><h3>Payment Delays</h3><p> Delayed receivables can disrupt cash flow. Factoring ensures timely access to funds while transferring collection responsibilities.</p></div></div>

          <div className="invoice-image">
           <img src={invoice} alt="Invoice" />
          </div>

          <div className="cardStyle"><div className="cardText"><h3>Unexpected Events</h3><p> External disruptions can impact financial stability. Invoice factoring offers a proactive approach to maintaining liquidity and resilience.</p></div></div>
        </div>
      </div>
    </div > /* close background */
  );
}

export default About;
